import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: max-content;
  margin: 50px 0 0 0;

  @media only screen and (${({theme}) => theme.media.large}) {
    margin: 100px 0 200px 0;
  }
`

export const Title = styled.div`
  padding: 0;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  text-transform: uppercase;

  @media only screen and (${({theme}) => theme.media.large}) {
    margin-bottom: 50px;
    padding: 0 300px 0 300px;
    font-size: 40px;
    font-weight: 600;
    line-height: 54px;
  }
`

export const Video = styled.video`
  width: 100%;
  height: auto;
`

export const Canvas = styled.canvas`
  position: absolute;
  left: 0;
  width: 320px;
  height: 320px;
  filter: blur(10px);
`